import { createContext, useContext, useState, useEffect, useCallback } from "react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
// URL directa a un recurso del backend (p. ej. <img src>); la cookie de sesión viaja sola.
export const urlApi = (path) => `${API}${path}`;
const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const r = await fetch(`${API}/auth/me`, { credentials: "include" });
      if (!r.ok) throw new Error("Not authenticated");
      const data = await r.json();
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: si venimos del callback de OAuth, dejamos que AuthCallback maneje el session_id
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    await fetch(`${API}/auth/logout`, { method: "POST", credentials: "include" });
    setUser(null);
    window.location.href = "/";
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, login, logout, checkAuth }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

// Client HTTP con credenciales para todas las API calls
async function handle(r) {
  if (!r.ok) {
    if (r.status === 401) {
      // Sesión expirada: forzar recarga a login
      window.location.href = "/";
    }
    const body = await r.text().catch(() => "");
    throw new Error(`HTTP ${r.status}: ${body || r.statusText}`);
  }
  return r.json();
}
export const api = {
  get: (path, headers) => fetch(`${API}${path}`, { credentials: "include", headers }).then(handle),
  post: (path, body, headers = {}) =>
    fetch(`${API}${path}`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json", ...headers },
      body: JSON.stringify(body),
    }).then(handle),
  del: (path) => fetch(`${API}${path}`, { method: "DELETE", credentials: "include" }).then(handle),
  // Sube un archivo (multipart). `campos` son campos extra del formulario.
  upload: (path, archivo, campos = {}) => {
    const fd = new FormData();
    fd.append("archivo", archivo);
    Object.entries(campos).forEach(([k, v]) => fd.append(k, v));
    return fetch(`${API}${path}`, { method: "POST", credentials: "include", body: fd }).then(handle);
  },
  // Descarga un archivo protegido y regresa el Blob.
  blob: (path) =>
    fetch(`${API}${path}`, { credentials: "include" }).then(async (r) => {
      if (!r.ok) {
        if (r.status === 401) window.location.href = "/";
        throw new Error(`HTTP ${r.status}`);
      }
      return r.blob();
    }),
};
